import PageHeader from "components/PageHeader";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Template } from "layouts/Template";
import { Check } from "tabler-icons-react";
import useGetParent from "hooks/useGetParent";
import axios from "axios";
import { NUMBER_VERIFIER_PATH } from "routes/api.path";
import { useDispatch } from "react-redux";
import { setParentForm } from "redux_dir/features/parentSlice";

function PayementSuccessPage() {
  const navigation = useNavigate();
  const parent = useGetParent();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  // Recharger les données du parent après le paiement
  useEffect(() => {
    const reloadParentData = async () => {
      if (parent?.phone) {
        try {
          // Attendre 3 secondes pour que le webhook Wave soit traité
          await new Promise(resolve => setTimeout(resolve, 3000));

          const response = await axios.get(NUMBER_VERIFIER_PATH + parent.phone + "/");
          if (response?.data?.user) {
            dispatch(setParentForm(response.data.user));
            console.log("✅ Données parent rechargées:", response.data.user);
          }
        } catch (error) {
          console.error("❌ Erreur rechargement parent:", error);
        } finally {
          setLoading(false);
        }
      } else {
        console.warn("⚠️ Pas de numéro de téléphone parent");
        setLoading(false);
      }
    };

    reloadParentData();
  }, [parent?.phone, dispatch]);

  return (
    <Template
      header={<PageHeader title={"Paiement"} />}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 20,
        padding: 10,
      }}
    >
      <div className="flex flex-col gap-4 items-center">
        <div className=" w-10 h-10 flex items-center justify-center rounded-full bg-[green] shadow-lg">
          <Check color="#fff" size={25} />
        </div>
        <div className="text-[25px] text-center">
          Votre paiement a été effectué avec succès
        </div>
        <div className="text-lg text-center text-gray-600">
          <span className="font-bold text-green-600">+3000 crédits</span> ajoutés à votre compte
        </div>
        {loading ? (
          <div className="text-sm text-center text-gray-500">
            Mise à jour du solde...
          </div>
        ) : parent?.credits ? (
          <div className="text-sm text-center text-gray-500">
            Nouveau solde : <span className="font-bold">{parent.credits} crédits</span>
          </div>
        ) : null}
      </div>
      <div
        className="flex items-center justify-center cursor-pointer gap-5 text-white p-3 my-4 bg-[#1AB3E5] rounded-full mx-3"
        data-testid="cypress-welcom-button"
        onClick={() => navigation("/", { replace: true })}
      >
        Retour a la page d'accueil
      </div>
    </Template>
  );
}

export default PayementSuccessPage;
